// .env constants

const {
    REACT_APP_ENV,
    REACT_APP_VERSION,

    REACT_APP_APP_NAME,
    REACT_APP_URL,
    REACT_APP_API_URL,

    REACT_APP_BUGSNAG_KEY,
    REACT_APP_GOOGLE_MAPS_KEY,
    REACT_APP_STRIPE_KEY,
    REACT_APP_GA_MEASUREMENT_ID,
} = process.env;

// APP CONSTANTS
const app = {
    ENV: REACT_APP_ENV,
    VERSION: REACT_APP_VERSION || '0.0.0',
    DEBUG: REACT_APP_ENV === 'local',
    MOCK: false,
    BACKEND: 'yii', // or 'laravel'

    APP_NAME: REACT_APP_APP_NAME || 'Scorchsoft React Boilerplate',

    APP_URL: REACT_APP_URL,
    API_URL: REACT_APP_API_URL,

    BUGSNAG_KEY: REACT_APP_BUGSNAG_KEY,
    GOOGLE_MAPS_KEY: REACT_APP_GOOGLE_MAPS_KEY,
    STRIPE_PUBLIC_KEY: REACT_APP_STRIPE_KEY,
    GA_MEASUREMENT_ID: REACT_APP_GA_MEASUREMENT_ID || '',

    AUTH_KEY: 'auth-key',
    LOCALSTORAGE_EXPIRES_KEY: 'session-token-expiry',
    LOCALSTORAGE_EXPIRES_TIME: '30', // minutes
};

export default app;
